import { render, staticRenderFns } from "./svideo.vue?vue&type=template&id=43b15c8a"
import script from "./svideo.vue?vue&type=script&lang=js"
export * from "./svideo.vue?vue&type=script&lang=js"
import style0 from "./svideo.vue?vue&type=style&index=0&id=43b15c8a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports